import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { RestResponse } from "../../shared/RestResponse";
import { environment } from "../../../environments/environment";

export interface City {
  id: number;
  name: string;
  stateName: string;
}

@Injectable({
  providedIn: 'root'
})
export class CityService {
  private readonly baseUrl = `${environment.base_url}/cities`;

  constructor(private http: HttpClient) {}

  list(search: string = ''): Observable<RestResponse<City[]>> {
    let params: any = {};
    if (search) {
      params.name = search;
    }
    return this.http.get<RestResponse<City[]>>(`${this.baseUrl}/list`, {params});
  }
}
